import MakeEntity from './MakeEntity.js'
import ModelEntity from './ModelEntity.js'
import VehicleEntity from './VehicleEntity.js'

export default class VehiclesEntitiesFactory {
  static makeEntity = ({id, image, isMostSearched, name, slug, url}) =>
    new MakeEntity({id, image, isMostSearched, name, slug, url})

  static modelEntity = ({id, bodyType, doors, image, make, name, slug, url}) =>
    new ModelEntity({id, bodyType, doors, image, make, name, slug, url})

  static vehicleEntity = ({
    acceleration,
    axisDistance,
    bodyType,
    bodyTypeId,
    carPlate,
    doors,
    fuelType,
    fuelTypeId,
    height,
    heightFromGround,
    hp,
    id,
    imageUrlPath,
    interiorDimensions,
    length,
    luggageCapacity,
    luggageCapacityExtended,
    luggageCategory,
    make,
    makeId,
    model,
    modelId,
    plateRegistrationDate,
    plateRegistrationYear,
    price,
    searchUrl,
    transmissionType,
    transmissionTypeId,
    url,
    version,
    versionId,
    weight,
    width,
    year
  }) =>
    new VehicleEntity({
      acceleration,
      axisDistance,
      bodyType,
      bodyTypeId,
      carPlate,
      doors,
      fuelType,
      fuelTypeId,
      height,
      heightFromGround,
      hp,
      id,
      imageUrlPath,
      interiorDimensions,
      length,
      luggageCapacity,
      luggageCapacityExtended,
      luggageCategory,
      make,
      makeId,
      model,
      modelId,
      plateRegistrationDate,
      plateRegistrationYear,
      price,
      searchUrl,
      transmissionType,
      transmissionTypeId,
      url,
      version,
      versionId,
      weight,
      width,
      year
    })
}
